import React, { useState } from "react";
import {
  Box,
  FormControlLabel,
  Checkbox,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import SearchOnMap from "../SearchOnMap";
import HistoryFilter from "../HistoryFilter";
import PersonIcon from "@mui/icons-material/Person";
import MapIcon from "@mui/icons-material/Map";

const MapHeader = ({
  folderPath,
  handleFolderClick,
  currentFolder,
  handleHistoryFilterChange,
  setCurrentLocation,
  mapRef,
  toggleUserInfo,
  setToggleUserInfo,
}) => {
  const handleUserToggle = () => {
    setToggleUserInfo(!toggleUserInfo);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "col",
          justifyContent: "start",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        {folderPath?.map((folder, index) => (
          <Box
            key={folder.id}
            onClick={() => handleFolderClick(folder)}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MDTypography
              sx={{
                borderRadius: "0.375em",
                cursor: "pointer",
                fontSize: "0.8em",
                ":hover": {
                  bgcolor: "rgba(255,255,255,0.2)",
                },
              }}
            >
              {folder.name}
            </MDTypography>
            {index !== folderPath.length - 1 && (
              <MDTypography>{"/"}</MDTypography>
            )}
          </Box>
        ))}
      </Box>

      {!toggleUserInfo && (
        <Box sx={{ width: "auto" }}>
          {currentFolder?.type === "user" ? (
            <HistoryFilter onFilterChange={handleHistoryFilterChange} currentFolder={currentFolder} />
          ) : (
            <SearchOnMap
              currentPage={"Map"}
              setCurrentLocation={setCurrentLocation}
              mapRef={mapRef}
            />
          )}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {currentFolder?.type === "user" && (
          <>
            {!toggleUserInfo ? (
              <Tooltip title="See User Details">
                <IconButton
                  onClick={handleUserToggle}
                  style={{ color: "#fff" }}
                >
                  <PersonIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="See Map">
                <IconButton
                  onClick={handleUserToggle}
                  style={{ color: "#fff" }}
                >
                  <MapIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default MapHeader;
